<template>
    <div>
        <p class="titleName">
            <span style="color:#00A5D5;">{{ secTitle }}</span>
            <span id="content" v-if="content != ''">( {{ content }})</span>
        </p>
        <!-- 上传文件入口 -->
        <div class="orderUpload">
            <div class="order-upload-wrap">
                <div class="order-file-wrap">
                    <el-upload class="upload-file model" action :before-upload="handleChange" :http-request="uploadFile"
                        :before-remove="beforeRemove"
                        :on-remove="(file, fileList) => { handleRemove(file, fileList, dataType) }"
                        :data="{ objectType: dataType, objectTag: subCatalogId + '_' + form.demPatient }"
                        :file-list="dataType == '07' ? dataScan : dataCbct" :on-exceed="handleExceed"
                        :auto-upload="true" :limit="3" multiple>
                        <div class="upload-file-dragger1">
                            <i class="el-icon-plus"></i>
                        </div>
                        <span id="tip" v-if="this.currentStep == 5&&dataScan.length==0">请上传扫描数据</span>
                    </el-upload>
                </div>
            </div>
        </div>
        <h2 id="example" @click="isShow = !isShow">示例</h2>
        <!-- 示例图片： -->
        <transition name="el-fade-in-linear">
            <div class="item" v-if="list.length == 3" v-show="isShow">
                <div class="example" v-for="(item, i) in list" :key="i" :style="i == 0 ? 'margin-left:50px;' : ''">
                    <img :src="item.imgUrl" alt="item.label" :style="i == 2 ? 'width:400px;' : ''" />
                </div>
            </div>
            <div class="item-two" v-if="list.length == 2" v-show="isShow">
                <div v-for="(item, i) in list" :key="i" :style="i == 1 ? 'margin-left:50px;' : ''">
                    <img :src="item.imgUrl" alt="item.label" />
                    <img class="copyright" src="/static/images/orthodontics/smiling-orthodontics.jpg">
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import EleUploadImage from "vue-ele-upload-image";
import BaseTag from '../../../components/BaseTag'
import {
    uploadByPieces
} from "../../../../common/upload.js";

export default {
    data() {
        return {
            imageUrl: '',
            distance: 0,//图片盒子间距
            uploadDistance: 0,//图片上传框间距
            titleName: '',
            secTitle: '',
            content: '',
            isShow: false,//是否显示示例图片
            dataList:[],
            dataScan:[],
            dataCbct:[]
        }
    },
    props: {
        subCatalogId: {
            type: String,
            default: ''
        },
        form: {
            type: Object,
            default() {
                return {}
            }
        },
        list: {
            type: Array,
            default() {
                return {}
            }
        },
        isEditServOrder: {
            type: String,
            default: '0'
        },
        currentStep: {
            type: Number,
            default: 0
        },
        dataType:{
            type:String,
            default:''
        }
    },
    methods: {
        handleChange() {

        },
        async uploadFile({
            response,
            file,
            data
        }) {
            var loading = this.$loading({
                text: '等待上传完成，已上传 0%'
            });

            uploadByPieces({
                file: file, // 文件
                data: data,
                pieceSize: 3, // 分片大小
                concurrent: 3,
                process: res => {
                    loading.setText('等待上传完成，已上传' + res + '%')
                    console.log('分片上传 -> process', res)
                },
                success: res => {
                    var temp = {
                        url: res.data.url,
                        name: file.name
                    }
                    if (data.objectType == '07') { //扫描数据
                        this.dataScan.push(temp)
                        this.dataList = this.dataScan
                    } else if (data.objectType == '10') { //CBCT数据
                        this.dataCbct.push(temp)
                        this.dataList = this.dataCbct
                    }
                    
                    // this.successFileCount += 1
                    loading.close();
                    this.$nextTick(() =>{
                        this.dataList = this.dataList.map(item =>{
                            let temp = {
                                name:item.name,
                                url:item.url
                            }
                            return temp;
                        });
                        this.transFile();
                        sessionStorage.setItem(''+this.dataType+'', JSON.stringify(this.dataList))
                    })
                },
                error: e => {
                    this.$yxz.msg('网络错误'.e, 'success')
                    console.log('分片上传 -> error', e)
                }
            })
        },
        transFile(){
            this.$emit('transFile',this.dataList,this.dataType)
        },
        beforeRemove(file,fileList) {
            return this.$confirm(`确定移除 ${file.name}?`);
        },
        handleExceed() {

        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        handlePictureCardPreview() {

        },
        handleRemove(file, fileList, type) {
            console.log('data',this.dataType,type)
            let name = ''
            let tempData = ''
            if (type == '07') {
                name = 'dataScan';
                tempData = this.dataScan;
            } else if (type == '10') {
                name = 'dataCbct';
                tempData = this.dataCbct;
                console.log('temp',tempData)
            }
            if (tempData == '') {
                this.$message("数据错误！！")
                return false
            }
            for (let i = 0; i < tempData.length; i++) {
                if (file.name === tempData[i].name) {
                    tempData.splice(i, 1);
                }
            }
            this.$message({
                type: 'success',
                message: '移除成功!'
            });
            this.fileNum -= 1
            console.log('dataList',this.dataType,this.dataList,this.dataScan)
            sessionStorage.setItem(''+this.dataType, JSON.stringify(this.dataList)) 
        },
        showStr() {
            this.titleName = '隐形矫治';
            if (this.currentStep == 5) {
                this.secTitle = '扫描数据';
                this.content = '提供稳定咬合关系的上、下颌模型光学数据；清晰连续的牙体、黏膜、唇（颊）系带、硬腭等重要解剖标志；若游离端缺失需种植，获取较多的缺失位远中黏膜信息；口内两侧最远端牙齿远中面信息获取。';
            } else if (this.currentStep == 6) {
                this.secTitle = 'CBCT数据';
                this.content = 'dicom格式，每张大小一致 。中视野/大视野，自然咬合状态。';
            }
        },
        loadSessionFile(){
            if(sessionStorage.getItem(''+this.dataType)){
                if(this.dataType=='07'){
                    this.dataScan = JSON.parse(sessionStorage.getItem(''+this.dataType));
                }else{
                    this.dataCbct = JSON.parse(sessionStorage.getItem(''+this.dataType));
                }
            }
            // this.transFile();
        }
    },
    watch: {
        currentStep(oldVal, newVal) {
            this.showStr()
        },
        dataType(newVal,oldVal){
            if(newVal){
                this.loadSessionFile()
            }
        }
    },
    created() {
        this.showStr()
    },
    mounted() {
        this.loadSessionFile();
    },
    components: {
        EleUploadImage,
        BaseTag
    }
}
</script>
<style lang="scss" scoped>
.titleName {
    width: 95%;
    font-weight:500;
    font-size:15px;
    position: relative;
    margin:10px 0 0 20px;
}
#content{
    position: absolute;
    top: -1px;
    left: 7%;
}

#example{
    font-size:18px;
    font-weight:700;
    text-align:center;
    color:#00A5D5;
    margin:10px 0;
}

.copyright {
    width: 30px;
    height: 30px;
    position: absolute;
    bottom: 1px;
    right: 0px;
    z-index: 99;
}

.orderUpload {
    height: 140px;
    margin: 10px 0px;
    display: flex;
}

/* create上传 */

.item,
.item-two {
    width: auto;
    height: 220px;
    margin: 0 auto;
    display: flex;
}

.item-two {
    width: 650px;
    height: 400px;
    position: relative;
    img {
        height: 400px;
    }
    .copyright{
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: 0%;
        right: -7.8%;
        z-index: 99;
    }
}

.example {
    justify-content: space-between;

    img:nth-of-type(1) {
        width: 300px;
        height: 250px;
        margin: 10px;
    }
}

.order-upload-wrap {
    display: flex;
    flex-direction: column;
    padding: 0 30px;
    width: 100%;
}

.upload-file {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
}

.upload-file-dragger1 {
    width: 100px;
    height: 100px;
    line-height: 100px;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 28px;
    color: #8c939d;
    margin-right: 80px;
}

.order-file-wrap {
    width: 100%;
    height: 120px;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 10px;
    margin: 15px 0;
    border: 1px solid rgba(0, 0, 0, .1);
}
#tip{
    position: absolute;
    top:40%;
    left: 30.7%;
    color: #75b9ff;
    z-index: 5555;
}
</style>
<style>
.model .el-icon-plus:before {
    line-height: 1;
}
</style>



// WEBPACK FOOTER //
// modelUpload.vue?e9b5967e